import { BookOutlined, LogoutOutlined, ContainerOutlined, SettingOutlined } from "@ant-design/icons"
import { ProductManagementIcon, StoreManagementIcon, UserManagementIcon } from "@components/Icon"
import { ROUTE } from "@constants"
import { RouteTreeNode } from "@/types"

export const ROUTES: RouteTreeNode = {
  path: ROUTE.HOMEPAGE,
  breadcrumbName: "route.homepageCrumb",
  label: "route.homepage",
  icon: <BookOutlined />,
  children: [
    {
      path: ROUTE.STORE_MANAGEMENT,
      breadcrumbName: "route.storeManagement",
      isShowBreadcrumbHeader: true,
      label: "route.storeManagement",
      icon: <StoreManagementIcon />,
      permission: "store:view",
      children: [
        {
          path: ROUTE.STORE_DEVICE,
          breadcrumbName: "route.storeDevice",
          isShowBreadcrumbHeader: true,
          permission: "device:update",
        },
      ],
    },
    {
      path: ROUTE.STORE_SETTING,
      breadcrumbName: "route.setting",
      icon: <SettingOutlined />,
      label: "route.setting",
      children: [
        {
          path: ROUTE.STORE_ADVERTISEMENT,
          breadcrumbName: "route.storeAdvertisement",
          label: "route.storeAdvertisement",
          isShowBreadcrumbHeader: true,
          permission: "campaign:update",
        },
        {
          path: ROUTE.STORE_CATALOG,
          breadcrumbName: "route.storeCatalogBreadcrumb",
          label: "route.storeCatalogTitle",
          isShowBreadcrumbHeader: true,
          permission: "catalog:update",
        },
        {
          path: ROUTE.STORE_PRODUCT_DISPLAY,
          breadcrumbName: "route.storeProductDisplay",
          label: "route.storeProductDisplay",
          isShowBreadcrumbHeader: true,
          permission: "product:update",
        },
      ],
    },
    {
      path: ROUTE.PRODUCT_MANAGEMENT,
      breadcrumbName: "route.productManagement",
      isShowBreadcrumbHeader: true,
      label: "route.productManagement",
      icon: <ContainerOutlined />,
      permission: "product:view",
      children: [
        {
          path: ROUTE.PRODUCT_UPDATE,
          breadcrumbName: "route.productDetailUpdate",
          isShowBreadcrumbHeader: true,
          permission: "product:create",
        },
        {
          path: ROUTE.PRODUCT_DETAIL,
          breadcrumbName: "route.productDetail",
          isShowBreadcrumbHeader: true,
          permission: "product:view",
        },
      ],
    },
    {
      path: ROUTE.TAG_MANAGEMENT,
      breadcrumbName: "route.tagManagement",
      isShowBreadcrumbHeader: true,
      label: "route.tagManagement",
      permission: "tag:view",
      icon: <ProductManagementIcon />,
    },
    {
      path: ROUTE.USER_MANAGEMENT,
      breadcrumbName: "route.userManagement",
      isShowBreadcrumbHeader: true,
      permission: "user:view",
      label: "route.userManagement",
      icon: <UserManagementIcon />,
    },
    {
      path: ROUTE.LOGOUT,
      label: "route.logout",
      icon: <LogoutOutlined />,
    },
  ],
}
